import { render, staticRenderFns } from "./PessoaInterface.vue?vue&type=template&id=71fa0e1b"
import script from "./PessoaInterface.vue?vue&type=script&lang=js"
export * from "./PessoaInterface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports